import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const RefreshIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M13.293 4 10.146.854a.5.5 0 0 1 .708-.708l3.995 3.996.005.004a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.707-.708L13.293 5H11.503C6.826 5.025 3 8.825 3 13.5a8.5 8.5 0 0 0 17 0 .5.5 0 0 1 1 0 9.5 9.5 0 0 1-19 0C2 8.267 6.278 4.028 11.497 4h1.796Z" />
  </IconWrapper>
)

export default RefreshIconMedium
